/**
 * Implémentation simple de EventEmitter pour le navigateur
 * Remplace le module 'events' de Node.js
 */
export class EventEmitter {
	private events: Record<string, Function[]> = {};

	/**
	 * Ajoute un écouteur d'événement
	 */
	public on(event: string, listener: Function): this {
		if (!this.events[event]) {
			this.events[event] = [];
		}
		this.events[event].push(listener);
		return this;
	}

	/**
	 * Retire un écouteur d'événement
	 */
	public off(event: string, listener: Function): this {
		if (!this.events[event]) return this;

		const index = this.events[event].indexOf(listener);
		if (index !== -1) {
			this.events[event].splice(index, 1);
		}
		return this;
	}

	/**
	 * Émet un événement avec les arguments fournis
	 */
	public emit(event: string, ...args: any[]): boolean {
		if (!this.events[event]) return false;

		this.events[event].forEach((listener) => {
			listener(...args);
		});
		return true;
	}

	/**
	 * Ajoute un écouteur qui ne sera appelé qu'une seule fois
	 */
	public once(event: string, listener: Function): this {
		const onceWrapper = (...args: any[]) => {
			listener(...args);
			this.off(event, onceWrapper);
		};

		return this.on(event, onceWrapper);
	}

	/**
	 * Retire tous les écouteurs d'un événement ou de tous les événements
	 */
	public removeAllListeners(event?: string): this {
		if (event) {
			delete this.events[event];
		} else {
			this.events = {};
		}
		return this;
	}
}
